import { FunctionComponent } from "react";

interface ITestimonialsheaderProps {
  title: string;
}

const TestimonialsHeader: FunctionComponent<ITestimonialsheaderProps> = ({title}) => (
  <h2 className="text-center md:text-left text-4xl tracking-wider font-sans font-semibold mb-12">
    {title}
  </h2>
);

export default TestimonialsHeader;